import React from 'react';
import cn from 'classnames';

import { Errors, ErrorBag } from '@inertiajs/core';
import TextInput from '../../../Components/Forms/TextInput';
import DecimalInput from '../../../Components/Forms/DecimalInput';
import rowHasErrors from '../Helpers/RowHasErrors';
import CarrierLossRatio from '../../../Data/CarrierLossRatio';

interface Props {
	currentYear: number;
	lossRatio: Partial<CarrierLossRatio>;
	index: number;
	errors: Errors & ErrorBag;
	updateIndex: (event: React.ChangeEvent<any>, index: number) => void;
	updateYear: (
		index: number,
		yearIndex: number,
		event: React.ChangeEvent<any>
	) => void;
}

const CarrierLossRatioRow = ({
	currentYear,
	lossRatio,
	index,
	errors,
	updateIndex,
	updateYear,
}: Props) => {
	const arrayName = 'carrier_loss_ratio';
	const errorArrayName = 'carrier_loss_ratios';
	return (
		<tr
			className={cn({
				'table-danger': rowHasErrors(errors, index),
			})}
		>
			<td
				id={`${arrayName}-${index + 1}`}
				className='row-num sticky-cell'
			>
				{index + 1}
			</td>
			<td>
				<TextInput
					name='carrier_name'
					index={index}
					value={lossRatio.carrier_name}
					onChange={(event) => updateIndex(event, index)}
					errors={errors}
					arrayName={arrayName}
					errorArrayName={errorArrayName}
				/>
			</td>
			{lossRatio.years?.map((year, yearIndex) => (
				<td key={`${index}-${year.year}`}>
					<DecimalInput
						name='loss_ratio'
						index={index}
						prefix={null}
						postfix='%'
						negativeValues={true}
						value={year.loss_ratio ?? ''}
						onChange={(event) =>
							updateYear(index, yearIndex, event)
						}
						errors={errors}
						arrayName={`${arrayName}-${index + 1} ${
							year.year
						}-loss_ratio`}
						errorArrayName={`${errorArrayName}.${index}.years.${yearIndex}.loss_ratio`}
						overrideArrayName={true}
						overrideErrorArrayName={true}
					/>
				</td>
			))}
		</tr>
	);
};

export default CarrierLossRatioRow;
